import {
    Box,
    Button,
    VStack,
    FormControl,
    FormLabel,
    Input,
    useToast,
    Spinner,
    Text,
    Divider,
    Heading,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import axios from "axios";
import { api_url } from "../../url";

export default function SocialLinksManager() {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const toast = useToast();

    const [formData, setFormData] = useState({
        whatsappNumber: "",
        telegramLink: "",
        instagramLink: "",
        supportEmail: "",
    });

    const fetchSettings = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            const { data } = await axios.get(`${api_url}/frontend/site-settings`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (data.success && data.data) {
                setFormData({
                    whatsappNumber: data.data.whatsappNumber || "",
                    telegramLink: data.data.telegramLink || "",
                    instagramLink: data.data.instagramLink || "",
                    supportEmail: data.data.supportEmail || "",
                });
            }
        } catch (error) {
            console.error("Failed to fetch settings", error);
            toast({
                title: "Fetch Failed",
                status: "error",
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSettings();
    }, []);

    const handleSubmit = async () => {
        setSaving(true);
        try {
            const token = localStorage.getItem("token");
            const res = await axios.put(`${api_url}/frontend/site-settings`, formData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (res.data.success) {
                toast({
                    title: "Settings Updated",
                    status: "success",
                    duration: 3000,
                });
            }
        } catch (error) {
            toast({
                title: "Update Failed",
                description: error.response?.data?.message || error.message,
                status: "error",
            });
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" py={10}>
                <Spinner />
            </Box>
        );
    }

    return (
        <Box maxW="600px" p={4}>
            <VStack spacing={6} align="stretch">
                <Box>
                    <Heading size="md" mb={2}>Social & Support Links</Heading>
                    <Text fontSize="sm" color="gray.500">
                        These links are used across the frontend for support and social icons.
                    </Text>
                </Box>
                
                <Divider />

                <FormControl>
                    <FormLabel fontWeight="bold">WhatsApp Number</FormLabel>
                    <Input 
                        value={formData.whatsappNumber} 
                        onChange={(e) => setFormData({ ...formData, whatsappNumber: e.target.value })} 
                        placeholder="e.g. 919876543210 (include country code, no +)" 
                    />
                    <Text fontSize="xs" color="gray.500" mt={1}>
                        Enter the full number including country code (e.g., 91 for India). No spaces or + sign.
                    </Text>
                </FormControl>

                <FormControl>
                    <FormLabel fontWeight="bold">Telegram Link</FormLabel>
                    <Input 
                        value={formData.telegramLink} 
                        onChange={(e) => setFormData({ ...formData, telegramLink: e.target.value })} 
                        placeholder="https://t.me/yourusername" 
                    />
                </FormControl>

                <FormControl>
                    <FormLabel fontWeight="bold">Instagram Link</FormLabel>
                    <Input 
                        value={formData.instagramLink} 
                        onChange={(e) => setFormData({ ...formData, instagramLink: e.target.value })} 
                        placeholder="https://instagram.com/yourprofile" 
                    />
                </FormControl>

                <FormControl>
                    <FormLabel fontWeight="bold">Support Email</FormLabel>
                    <Input 
                        value={formData.supportEmail} 
                        onChange={(e) => setFormData({ ...formData, supportEmail: e.target.value })} 
                        placeholder="support@jskbook.com" 
                    />
                </FormControl>

                <Box pt={4}>
                    <Button 
                        colorScheme="blue" 
                        onClick={handleSubmit} 
                        isLoading={saving}
                        w="full"
                    >
                        Save Settings
                    </Button>
                </Box>
            </VStack>
        </Box>
    );
}
